/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description Représentation d\'un détail (rôle, logiciel, etc.)
 */
export const groupSchema = z.object({
      "id": z.string().describe("ID unique de l'élément"),
  "name": z.string().describe("Nom de l'élément").optional(),
  "description": z.string().max(500).describe("Description de l'élément").optional(),
  "hidden": z.boolean().describe("Indique si l'élément est caché ou non").optional(),
  "enabled": z.boolean().describe("Indique si l'élément est activé ou non").optional(),
  "icon": z.string().describe("URL de l'icône associée à l'élément").optional(),
  "client": z.string().describe("nom du client associé à l'élément").optional(),
  "order": z.number().int().describe("Ordre de l'élément pour le tri").optional(),
  "type": z.string().describe("Type de l'élément (par exemple, \"role\" ou \"software\")").optional(),
  "group": z.string().describe("Groupe auquel appartient l'élément").optional(),
  "default": z.boolean().describe("Indique si l'élément est celui par défaut").optional()
      }).describe("Représentation d'un détail (rôle, logiciel, etc.)")